import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {SearchComponent} from './search.component';
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule, MultiSelectModule} from "primeng/primeng";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from "@ngx-translate/core";
import {DownloadModule} from "../download/download.module";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    GrowlModule,
    ModalModule.forRoot(),
    NgbModule,
    CoreModule,
    TableModule,
    MultiSelectModule,
    TranslateModule,
    DownloadModule
  ],
  declarations: [SearchComponent]
})
export class SearchModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.module.ts